import React from 'react';

import classNames from "classnames";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import styles from "../../styles/stats-widget-placeholders.module.scss";
import {MatchEventModulePlaceholderRound} from "./stats.widget.placeholder.round";
import {StatsWidgetPlaceholderRow} from "./stats.widget.placeholder.row";

export const StatsWidgetPlaceholder = () => {
  return (
    <div className={classNames(styles.placeholder)}>
      <PlaceholderWrapperComponent className={classNames(styles.container)}>
        <div className={classNames(styles.container)}>
          <MatchEventModulePlaceholderRound/>
          <StatsWidgetPlaceholderRow/>
          <StatsWidgetPlaceholderRow/>
          <StatsWidgetPlaceholderRow/>
          <div className={classNames(styles.footer)}/>
        </div>
      </PlaceholderWrapperComponent>
    </div>
  )
};
